import { Address6 } from 'ip-address';
export const last = list => list[list.length - 1];
export const formatStringNoBreaks = value => {
  var _value$trim$replace;
  // 将换行符、制表符替换为空格
  return (_value$trim$replace = value === null || value === void 0 ? void 0 : value.trim().replace(/[\r\n\t\f\v]+/g, ' ')) !== null && _value$trim$replace !== void 0 ? _value$trim$replace : '';
};

// 匹配空格、换行符、制表符、顿号、逗号（全角/半角）、分号（全角/半角）、竖线（全角/半角）
const spliterReg = /[\s,，;；、|｜]+/g;
// 匹配换行符、制表符、顿号、逗号（全角/半角）、分号（全角/半角）、竖线（全角/半角）
const spliterNoSpaceReg = /[\r\n\t\f\v,，;；、|｜]+/g;
export const formatValueText = (value, item) => {
  var _value$trim;
  // 获取输入值，去除首尾空格，如果为空则返回空字符串
  const text = (_value$trim = value === null || value === void 0 ? void 0 : value.trim()) !== null && _value$trim !== void 0 ? _value$trim : '';

  // 如果当前项允许多选
  if (item.multiple) {
    // 如果是select
    if (item.mode === 'select') {
      // 使用无空格的分隔符替换为'|'
      return text.replace(spliterNoSpaceReg, '|');
    }
    // 使用分隔符替换为'|'
    return text.replace(spliterReg, '|');
  }
  // 格式化字符串，去除换行符
  return formatStringNoBreaks(text);
};
const isNumStr = value => {
  if (!/^\d+$/.test(value)) {
    return false;
  }
  return value.startsWith('0') ? value === '0' : true;
};
const isNumInRange = (range, value) => {
  if (typeof value === 'string' && !isNumStr(value)) {
    return false;
  }
  const num = Number(value);
  return num >= range[0] && num <= range[1];
};
const multipleMatch = (str, match) => {
  return str.trim().split(spliterReg).every(match);
};
const isUidNum = str => {
  return /^[0-9]{16,}$/.test(str);
};
const isUid32 = str => {
  return /^[0-9a-z]{32}$/.test(str) || /^[0-9a-z]{8}(-[0-9a-z]{4}){3}-[0-9a-z]{12}$/.test(str);
};
const isUuid = str => {
  return isUidNum(str) || isUid32(str);
};
const isLikeIPv4 = str => {
  if (!str || str.includes('..') || str.includes('./')) {
    return false;
  }
  const [ip, mask, ...rest] = str.split('/');
  if (rest.length > 0) {
    return false;
  }
  if (mask && !isNumInRange([0, 32], mask)) {
    return false;
  }
  const ipNums = ip.split('.');
  return ipNums.length <= 4 && ipNums.every(n => !n || isNumInRange([0, 255], n));
};
const isIP = str => {
  return isLikeIPv4(str) || Address6.isValid(str);
};
const isEmail = str => {
  return /^[0-9a-zA-Z\._-]+@[0-9a-zA-Z_-]+(\.[0-9a-zA-Z_-]+)+$/.test(str);
};
export const isMatched = (match, str, multiple) => {
  const testBy = fn => {
    return multiple ? multipleMatch(str, fn) : fn(str);
  };
  switch (match) {
    case 'uuid':
      return testBy(isUuid);
    case 'uid-num':
      return testBy(isUidNum);
    case 'uid-32':
      return testBy(isUid32);
    case 'email':
      return testBy(isEmail);
    case 'ip':
      return testBy(isIP);
    case 'ipv4':
      return testBy(isLikeIPv4);
    case 'ipv6':
      return testBy(Address6.isValid);
    default:
      if (match instanceof RegExp) {
        return testBy(match.test);
      }
      if (typeof match === 'function') {
        return testBy(match);
      }
      return false;
  }
};